import { render, staticRenderFns } from "./Fruit.vue?vue&type=template&id=cf853586&scoped=true&"
import script from "./Fruit.vue?vue&type=script&lang=js&"
export * from "./Fruit.vue?vue&type=script&lang=js&"
import style0 from "./Fruit.vue?vue&type=style&index=0&id=cf853586&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf853586",
  null
  
)

export default component.exports